import { render, staticRenderFns } from "./ShareFeedback.vue?vue&type=template&id=58aad618&scoped=true"
import script from "./ShareFeedback.vue?vue&type=script&lang=ts"
export * from "./ShareFeedback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aad618",
  null
  
)

export default component.exports